import { BoardCardType } from "@fry/boards/lib"
import { BookingAvailableSettingsComponent } from "./booking-available-card.settings.component"
import { BookingAvailableCardViewComponent } from "./booking-available-card.view.component"


export const BookingAvailableCard: BoardCardType = {
    name: 'booking-available',
    title: $localize `Available bookings`,
    viewComponent: BookingAvailableCardViewComponent,
    editComponent: BookingAvailableSettingsComponent,
}